import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from "@angular/core";

import { NzSafeAny } from "ng-zorro-antd/core/types";

import { NzTableContentComponent } from "ng-zorro-antd/table";
import { UiTableLayout } from "@webapp/ui/table/table.models";

@Component({
  selector: "table[ui-table-content]",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "table-content.component.html",
})
export class UiTableContentComponent extends NzTableContentComponent {
  @Input("tableLayout") public tableLayout: UiTableLayout = "auto";
  @Input("theadTemplate") public theadTemplate: TemplateRef<NzSafeAny> | null = null;
  @Input("contentTemplate") public contentTemplate: TemplateRef<NzSafeAny> | null = null;
  @Input("listOfColWidth") public listOfColWidth: ReadonlyArray<string | null> = [];
  @Input("scrollX") public scrollX: string | null = null;
}
